// extracted by mini-css-extract-plugin
export default {"promo__item":"PromoItem_promo__item__y-qSy","check":"PromoItem_check__ulP24"};